// Determines if the current hostname corresponds to a tenant-specific domain.
// A hostname is considered a tenant domain if:
// - It has more than 3 segments (e.g., tenant.nda.com.ar) or
// - It's a localhost address with more than one segment (e.g., tenant.localhost),
// and:
// - The first segment does not include "app" (to exclude the app frontend domain),
// - The first segment does not include "aws" (to exclude infrastructure-related domains).
const isTenant = (
    (window.location.hostname.split('.').length > 3 || 
    (window.location.hostname.includes('localhost') && window.location.hostname.split('.').length > 1)) &&
    !window.location.hostname.split('.')[0].includes('app') &&
    !window.location.hostname.split('.')[0].includes('aws')
);

function getIsTenant() {
    return isTenant;
}

export { getIsTenant };